import { useCallback } from 'react'
import { useLocation, useNavigate, type NavigateOptions } from 'react-router-dom'

/** Detay/özet sayfasına gidilirken location.state'te taşınan "geri dönülecek kaynak konum" (pathname + search). */
export interface OriginState {
  from?: string
}

/**
 * Bir detay/özet sayfasına giderken çağıranın o anki konumunu (pathname + search) {@link OriginState.from}'a
 * yazan navigate sarmalayıcısı. Detay sayfası "Geri/Listeye Dön" ile {@link useBackTo} üzerinden buraya döner —
 * böylece buton her zaman GELDİĞİ yere döner: anasayfa, filtreli liste (search korunur) veya toplantı detayı
 * fark etmeksizin. State kaybolursa (tam sayfa yenileme / derin link) detay sayfası kendi makul fallback'ine düşer.
 *
 * Kullanım: {@code const go = useNavigateWithOrigin(); go('/minutes/actions/' + id)}
 */
export function useNavigateWithOrigin() {
  const navigate = useNavigate()
  const location = useLocation()
  const from = location.pathname + location.search
  return useCallback(
    (to: string, options?: NavigateOptions) =>
      navigate(to, { ...options, state: { ...(options?.state as object | null), from } }),
    [navigate, from],
  )
}

/** Detay sayfası "Geri" hedefi: {@link useNavigateWithOrigin} ile taşınan origin varsa oraya, yoksa {@code fallback}'e. */
export function useBackTo(fallback: string): string {
  const location = useLocation()
  return (location.state as OriginState | null)?.from ?? fallback
}
